import useModelsData from "./useModelsData";
import _ from 'lodash';
import { isFacelift, getBaseGenId } from '../../../../../model/generations/ModelGenerationsData.mjs';

function yearStringToYears(rangeText) {
  if(_.isNumber(rangeText)) {
    return [rangeText];
  } else if (rangeText.match(/^\d\d\d\d-\d\d\d\d$/)) {
    let [from, to] = rangeText.split('-').map(y => parseInt(y.trim()));
    return [from, to];
  } else if (rangeText.match(/^\d\d\d\d \.\.\. \d\d\d\d$/)) {
    let [from, to] = rangeText.split('...').map(y => parseInt(y.trim()));
    return _.range(from, to + 1);
  } else if (rangeText.match(/^\d\d\d\d$/)) {
    return [parseInt(rangeText)];
  } else {
    console.warn(`Invalid year range "${rangeText}"`);
  }
}

export default function useContextValidator(context, localeContext) {
  const data = useModelsData();

  let explanation = '';
  let valid = true;

  if (context) {
    let { year, years, genId, modelId, country } = context;
    const ctxCountry = typeof country === 'string' ? country : 'global';

    let yearList = years && years.length
      ? years
      : (year != null ? (Array.isArray(year) ? year.flatMap(yearStringToYears) : yearStringToYears(year)) : []);

    // Resolve the generation definition for THIS model/country (falls back to the global def).
    let gen;
    if (genId) {
      gen = modelId ? data.getGenDef(genId, { modelId, country: ctxCountry }) : data.getBaseGenDef(genId);
    }

    if (yearList?.length && gen) {
      for (const y of yearList) {
        if (gen.fromYear && (y < (gen.fromYear - 1) || (gen.toYear && y > (gen.toYear + 1)))) {
          valid = false;
          explanation += `Year ${y} is out of range for generation ${genId} [${gen.fromYear} ... ${gen.toYear || 'present'}]. `;
        }
      }
    }

    // The genId must be among the generations declared for this model/country (when any are declared).
    if (modelId && genId) {
      const list = data.gens(modelId, ctxCountry);
      if (list.length) {
        const inList = list.some(g => g.genId === genId)
          || (isFacelift(genId) && list.some(g => g.genId === getBaseGenId(genId)));
        if (!inList) {
          valid = false;
          explanation += `Generation ${genId} is not declared for model ${modelId}. `;
        }
      }
    }

    const localeModels = localeContext ? data.modelsInLocale(localeContext) : null;
    if (modelId && localeModels && !localeModels.has(modelId)) {
      valid = false;
      explanation += `Model ${modelId} is not available in locale ${localeContext}. `;
    }
  }

  return [valid, explanation];
}
